import { Badge as BadgeMantine, BadgeProps } from "@mantine/core";
import { IColor, variantColors } from "../../../utils/selectColors";
import { useTranslation } from "react-i18next";

interface IProps extends BadgeProps {
  status?: IColor;
  title?: string;
  select?: boolean;
  border?: boolean;
}

const TagStatus = ({ status, title, select, border, ...props }: IProps) => {
  const { t } = useTranslation();
  const colorSelected: IColor = !!status ? status : IColor.babyBlue;
  const selectedVariant = variantColors[colorSelected];

  return (
    <BadgeMantine
      styles={{
        root: {
          color: selectedVariant.color,
          background: selectedVariant.bg,
          padding: select ? "5px 10px" : "4px 8px",
          height: select ? "40px" : "30px",
          fontSize: select ? "16px" : "14px",
          border: "1px solid",
          width: "fit-content",
          borderColor: border ? selectedVariant.borderColor : "transparent",
        },
      }}
      radius="sm"
      {...props}
    >
      {title
        ? title
        : t(selectedVariant.text || "global.variant_color.waiting")}
    </BadgeMantine>
  );
};

export default TagStatus;
